import __request__ from 'routing/request';
/**
 * Trigger team sync for the given authentication service backend
 */
export function triggerSync(authServiceId: string): Promise<unknown> {
    return __request__('POST', `/plugins/org.graylog.plugins.security/team-sync/trigger/${authServiceId}`, null, {}, {
        'Accept': ['application/json']
    });
}
